/* The default authentification value */
export const INITIAL_STATE = {
    status: 'SIGNIN',
    firebaseAuth: undefined,
    auth: undefined,
    email: '',
    password: '',
    loading: false,
    initialLoading: true,
    reauthenticating: false,
    errorCode: undefined,
    emailErrorCode: undefined,
    passwordErrorCode: undefined,
};
